<template>
  <div class="notice-news-container">
    <h2>学术委员会</h2>
    <div v-if="list.length">
      <div class="notice-news-list">
        <template v-for="(item, index) in list">
          <list-item :key="index" :info="item"></list-item>
        </template>
      </div>
      <!-- 分页 -->
      <!-- <pagination v-show="total>0" :total="total" :page.sync="pageParams.pageNumber" :limit.sync="pageParams.pageSize" @pagination="getPageData" /> -->
    </div>
    <div class="none-result" v-else>
      暂无学术委员会信息
    </div>
  </div>
</template>

<script>
import { contentFinds } from "@/api/common/content";
import ListItem from "./components/listItem";

export default {
  data() {
    return {
      list: [],
      total: 0,
      queryBean: {
        contentBean: {
          type1: "学术委员会",
        },
      },
      pageParams: {
        pageNumber: 1,
        pageSize: 99,
        sort: "priority, publish_time",
        order: "desc"
      },
    }
  },
  props: {

  },
  components: {
    ListItem
  },
  mounted() {
    this.getPageData();
  },
  methods: {
    getData(params) {
      let data = Object.assign({}, this.pageParams, this.queryBean, params || {});
      return new Promise(async (resolve, reject) => {
        const res = await contentFinds(data);
        if (res.status == 200) {
          resolve(res.data)
        }
      })
    },
    getPageData() {
      this.getData().then(res => {
        this.list = res.list;
        this.total = res.total;
      })
    }
  },
}
</script>

<style lang="less" scoped>
.notice-news-container {
  width: 100%;
  h2 {
    font-weight: 600;
    font-size: 28px;
    line-height: 45px;
    text-align: center;
    color: #212529;
    margin-bottom: 30px;
  }

  .notice-news-list {
    display: flex;
    justify-content: flex-start;
    flex-wrap: wrap;
    gap: 20px;
    border-top: 1px dashed #dae0ee;
    padding-top: 10px;
  }

  .none-result {
    text-align: center;
    font-size: 16px;
    color: #999;
    line-height: 60px;
    margin: 30px;
  }
}

@media screen and (max-width: 768px) {
  .notice-news-container {
    .notice-news-list {
      gap: 14px;
    }

    .none-result {
      font-size: 14px;
    }
  }
}
</style>